import { useTranslation } from "shared/localization/localization";
import { AlertOrangeIcon } from "shared/ui/Icons";
import { Portal } from "shared/ui/Portal";
import styles from "./AppIntegrationApiAccessModal.module.scss";

type AppIntegrationApiAccessModalProps = {
  className?: string;
  accessDenied: boolean;
  requestLimitReached: boolean;
};

const ModalWrapper: RFC = ({ children }) => (
  <Portal className={styles.modal}>
    <div className={styles.content}>
      <AlertOrangeIcon className={styles.icon} />
      {children}
    </div>
  </Portal>
);

export const AppIntegrationApiAccessModal: RFC<AppIntegrationApiAccessModalProps> = ({
  accessDenied,
  requestLimitReached,
}) => {
  const { t } = useTranslation();

  if (accessDenied) {
    return (
      <ModalWrapper>
        <p className={styles.title}>{t("Access is denied by system guard")}</p>
        <p className={styles.text}>{t("Please contact the website owner for extended access")}</p>
      </ModalWrapper>
    );
  }

  if (requestLimitReached) {
    return (
      <ModalWrapper>
        <p className={styles.title}>{t("The service is currently unavailable")}</p>
        <p className={styles.text}>{t("Please contact the website owner for extended access")}</p>
      </ModalWrapper>
    );
  }

  return null;
};
